import styled from 'styled-components';

export const Loader = styled.div`
  flex: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1299;
  background: white;
  cursor: progress;
`